import { API } from '@aws-amplify/api'
import {
  addITAdminUnassignedData,
  updateITAdminUnAssignedDataFetchInProgress,
  addITAdminAssignedData,
  updateITAdminAssignedDataFetchInProgress,
  addITAdminQCCasesData,
  updateITAdminQCDataFetchInProgress,
  addITAdminCompleteData,
  addITAdminSettingsData,
  updateITAdminCompleteDataFetchInProgress,
  updateITAdminStatesFetchInProgress,
  addITAdminStateData,
  deleteSettingsData,
  addSettingsData,
  editSettingsData,
} from '../actions'
import { WOMA_API_GATEWAY_NAME } from '../../constants/aws'

interface DataRequest {
  id?: string | null | string[]
  pageIndex?: number | 1
  pageSize?: number | 10
  caseView: string
  filterField: string | null
  filterValue: any | Record<string, unknown> | null //chaanged to Record for linting
  startDate: string | null
  endDate: string | null
  sortOrder: string | null
  sortField: string | null
}
interface ITAdminSettings {
  pathology_procedure_code: number
  id?: number | null
  cdx_procedure_code: number
  description: string | string[]
}
export const getITAdminUnassignedData =
  ({
    id,
    pageIndex,
    pageSize,
    filterField,
    filterValue,
    caseView,
    startDate,
    endDate,
    sortOrder,
    sortField,
  }: DataRequest) =>
  async (dispatch) => {
    if (!id || id instanceof Array) return

    const apiName = '/case-management/labmanager/all-cases'
    try {
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          page_number: pageIndex ? pageIndex : 1,
          page_size: pageSize ? pageSize : 10,
          filterField: filterField,
          filterValue: filterValue,
          caseView: caseView,
          startDate: startDate,
          endDate: endDate,
          sortOrder: sortOrder,
          sortField: sortField,
        },
      }
      dispatch(updateITAdminUnAssignedDataFetchInProgress(true))
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${id}`, options)

      if (result?.data) {
        dispatch(addITAdminUnassignedData({ payload: result, userId: id }))
      }
    } catch (err) {
      console.log('getITAdminUnassignedData Error', err)
    } finally {
      dispatch(updateITAdminUnAssignedDataFetchInProgress(false))
    }
  }
export const getITAdminAssignedData =
  ({
    id,
    pageIndex,
    pageSize,
    filterField,
    filterValue,
    caseView,
    startDate,
    endDate,
    sortOrder,
    sortField,
  }: DataRequest) =>
  async (dispatch) => {
    if (!id || id instanceof Array) return

    const apiName = '/case-management/labmanager/all-cases'
    try {
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          page_number: pageIndex ? pageIndex : 1,
          page_size: pageSize ? pageSize : 10,
          filterField: filterField,
          filterValue: filterValue,
          caseView: caseView,
          startDate: startDate,
          endDate: endDate,
          sortOrder: sortOrder,
          sortField: sortField,
        },
      }

      dispatch(updateITAdminAssignedDataFetchInProgress(true))
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${id}`, options)

      if (result?.data) {
        dispatch(addITAdminAssignedData({ payload: result, userId: id }))
      }
    } catch (err) {
      console.log('getITAdminAssignedData Error', err)
    } finally {
      dispatch(updateITAdminAssignedDataFetchInProgress(false))
    }
  }

export const getITAdminQCCasesData =
  ({ id, pageIndex, pageSize }: DataRequest) =>
  async (dispatch) => {
    if (!id || id instanceof Array) return

    const apiName = '/case-management/labmanager/all-cases'
    try {
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          page_number: pageIndex ? pageIndex : 1,
          page_size: pageSize ? pageSize : 10,
        },
      }
      dispatch(updateITAdminQCDataFetchInProgress(true))
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${id}`, options)

      if (result?.data) {
        dispatch(addITAdminQCCasesData({ payload: result, userId: id }))
      }
    } catch (err) {
      console.log('getITAdminQCCasesData Error', err)
    } finally {
      dispatch(updateITAdminQCDataFetchInProgress(false))
    }
  }

export const getITAdminCompleteData =
  ({
    id,
    pageIndex,
    pageSize,
    filterField,
    filterValue,
    caseView,
    startDate,
    endDate,
    sortOrder,
    sortField,
  }: DataRequest) =>
  async (dispatch) => {
    if (!id || id instanceof Array) return

    const apiName = '/case-management/labmanager/all-cases'
    try {
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          page_number: pageIndex ? pageIndex : 1,
          page_size: pageSize ? pageSize : 10,
          filterField: filterField,
          filterValue: filterValue,
          caseView: caseView,
          startDate: startDate,
          endDate: endDate,
          sortOrder: sortOrder,
          sortField: sortField,
        },
      }
      dispatch(updateITAdminCompleteDataFetchInProgress(true))
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${id}`, options)

      if (result?.data) {
        result.data = result?.data.map((value, i) => {
          value.rowId = i + 1
          return value
        })

        dispatch(addITAdminCompleteData({ payload: result, userId: id }))
      }
    } catch (err) {
      console.log('getITAdminCompleteData Error', err)
    } finally {
      dispatch(updateITAdminCompleteDataFetchInProgress(false))
    }
  }

export const getITAdminSettingsData =
  ({ id }) =>
  async (dispatch) => {
    const apiName = '/app-config'
    try {
      const options = {
        headers: {},
        response: false,
      }

      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${id}`, options)

      if (result) {
        dispatch(addITAdminSettingsData({ payload: result.procedure_codes }))
      }
    } catch (err) {
      console.log('getITAdminSettingsData Error', err)
    }
  }
export const ITAdminSettingsUpdate =
  ({ payload }) =>
  async (dispatch) => {
    let action = ''
    const apiName = '/settings/procedure-code'
    try {
      const options = {
        headers: {},
        response: false,
        body: payload,
      }
      const result = await API.put(WOMA_API_GATEWAY_NAME, `${apiName}`, options)
      action = 'EDIT_SETTING_SUCCESS'
    } catch (err) {
      action = 'EDIT_SETTING_ERROR'
      console.log('ITAdminSettingsUpdate Error', err)
    } finally {
      dispatch(editSettingsData({ action: action }))
    }
  }
export const AddITAdminSettings =
  ({ payload }) =>
  async (dispatch) => {
    let action = ''
    const apiName = '/settings/procedure-code'
    try {
      const options = {
        headers: {},
        response: false,
        body: payload,
      }
      const result = await API.post(WOMA_API_GATEWAY_NAME, `${apiName}`, options)
      action = 'ADD_SETTING_SUCCESS'
    } catch (err) {
      if (err instanceof Object) {
        console.log(err.toString())
        const errMsg = err.toString()
        if (errMsg.substring(7, errMsg.toString().length) == 'Request failed with status code 500')
          action = 'ADD_DUPLICATE_SETTING'
        else action = 'ADD_SETTING_ERROR'
      }
      console.log('AddITAdminSettings Error', err)
    } finally {
      dispatch(addSettingsData({ action: action }))
    }
  }

export const DeleteITAdminSettings =
  ({ payload }) =>
  async (dispatch) => {
    let action = ''
    const apiName = '/settings/procedure-code'
    try {
      const options = {
        headers: {},
        response: false,
        body: payload,
      }
      const result = await API.del(WOMA_API_GATEWAY_NAME, `${apiName}`, options)
      action = 'DELETE_SETTING_SUCCESS'
    } catch (err) {
      action = 'DELETE_SETTING_ERROR'
      console.log('DeleteITAdminSettings Error', err)
    } finally {
      dispatch(deleteSettingsData({ action: action }))
    }
  }

export const getITAdminStateData = () => async (dispatch) => {
  const apiName = '/settings/states'
  try {
    const options = {
      headers: {},
      response: false,
    }
    dispatch(updateITAdminStatesFetchInProgress(true))
    const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}`, options)
    if (result) {
      dispatch(addITAdminStateData({ payload: result }))
    }
  } catch (err) {
    console.log('getITAdminSettingsData Error', err)
  } finally {
    dispatch(updateITAdminStatesFetchInProgress(false))
  }
}

export const UpdateITAdminStateData =
  ({ payload }) =>
  async (dispatch) => {
    let action = ''

    const apiName = '/settings/states'
    try {
      const options = {
        headers: {},
        response: false,
        body: payload,
      }
      const result = await API.put(WOMA_API_GATEWAY_NAME, `${apiName}`, options)
      action = 'EDIT_STATE_SUCCESS'
    } catch (err) {
      action = 'EDIT_STATE_ERROR'
      console.log('ITAdminSettingsUpdate Error', err)
    } finally {
      dispatch(editSettingsData({ action: action }))
    }
  }

export const AddITAdminStateData =
  ({ payload }) =>
  async (dispatch) => {
    let action = ''
    const apiName = '/settings/states'
    try {
      const options = {
        headers: {},
        response: false,
        body: payload,
      }
      const result = await API.post(WOMA_API_GATEWAY_NAME, `${apiName}`, options)
      action = 'ADD_STATE_SUCCESS'
    } catch (err) {
      if (err instanceof Object) {
        console.log(err.toString())
        action = 'ADD_STATE_ERROR'
      }
      console.log('AddITAdminSettings Error', err)
    } finally {
      dispatch(addSettingsData({ action: action }))
    }
  }

export const DeleteITAdminStateData =
  ({ payload }) =>
  async (dispatch) => {
    let action = ''
    const apiName = '/settings/states'
    try {
      const options = {
        headers: {},
        response: false,
        body: payload,
      }
      const result = await API.del(WOMA_API_GATEWAY_NAME, `${apiName}`, options)
      action = 'DELETE_STATE_SUCCESS'
    } catch (err) {
      action = 'DELETE_STATE_ERROR'
      console.log('deleteStateData Error', err)
    } finally {
      dispatch(deleteSettingsData({ action: action }))
    }
  }
